import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  uploadArtworkRequest,
  uploadArtworkSuccess,
  uploadArtworkFailure,
} from "../reducer/ArtworkReducer";

// Worker saga
function* uploadArtwork(action) {
  try {
    const file = action.payload;
    if (!file) throw new Error("No file selected");

    const token = localStorage.getItem("access_token");

    const formData = new FormData();
    formData.append("file", file);

    const response = yield call(
      axios.post,
      "https://dotconnect.dotandkey.com/api/v1/artwork/upload",
      formData,
      {
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Upload Response:", response.data);

    yield put(uploadArtworkSuccess(response.data));
  } catch (error) {
    console.error("Upload Error:", error.response || error);
    yield put(
      uploadArtworkFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
}

// Watcher saga
export function* watchUploadArtwork() {
  yield takeLatest(uploadArtworkRequest.type, uploadArtwork);
}

// Export as array for root saga
export default [watchUploadArtwork()];
